import { parsePhoneNumberFromString } from 'libphonenumber-js'

export default {
    methods: {
        isNumber: function(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();;
            } else {
                return true;
            }
        },
        getAgeFromBday: bday => {
            var birth = new Date(bday)
            var curr  = new Date()
            var diff = curr.getTime() - birth.getTime()
            var age = Math.floor(diff / (1000 * 60 * 60 * 24 * 365.25))
            return age
        },

        formatNumber: (number) => {
            let tmp = number;
            if (!tmp.startsWith('+'))
                tmp = '+' + tmp;
        
            try {
                let phoneNumber = parsePhoneNumberFromString(tmp)
                if (phoneNumber)
                {
                    tmp = phoneNumber.formatNational()
                }
            } catch (error) {
            }
            return tmp;
        }
    }
}
